import { CommonPipesModule } from 'app/shared/pipes/common-pipes.module';
import { ResolvePepMatchComponent } from './actual/politicallyexposed/resolvepepmatch/resolve-pepmatch.component';
import { ResolveBadPressMatchComponent } from './actual/badpress/resolvebadpress/resolve-badpress.component';
import { ResolveSanctionMatchComponent } from './actual/sanction/resolvesanction/resolve-sanction.component';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { JustgageModule } from 'angular2-justgage';
import {
    EditorModule,
    TabViewModule,
    CalendarModule,
    DataTableModule,
    MenubarModule,
    ConfirmDialogModule,
    ConfirmationService
} from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';
import { AutoCompleteModule } from 'primeng/primeng';
import { DomSanitizer } from '@angular/platform-browser';

import { EntityMonitoringComponent } from 'app/entities/monitoring/entity-monitoring.component';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';

import { EntityMonitoringClientComponent } from 'app/entities/monitoring/entitymonitoringclient/entity-monitoring-client.component';
import { EntityMonitoringOrgComponent } from 'app/entities/monitoring/entitymonitoringorg/entity-monitoring-org.component';
import { EntityMonitoringPersonComponent } from 'app/entities/monitoring/entitymonitoringperson/entity-monitoring-person.component';

import { ElaborationComponent } from 'app/entities/monitoring/actual/elaboration/elaboration.component';

import { SanctionInfoComponent } from 'app/entities/monitoring/actual/sanction/sanctioninfo/sanction-info.component';
import {
    PoliticallyExposedInfoComponent
} from 'app/entities/monitoring/actual/politicallyexposed/politicallyexposedinfo/politically-exposed-info.component';
import { BadPressInfoComponent } from 'app/entities/monitoring/actual/badpress/badpressinfo/bad-press-info.component';

import { SanctionMatchComponent } from 'app/entities/monitoring/actual/sanction/sanctionmatch/sanction-match.component';
import {
    PoliticallyExposedMatchComponent
} from 'app/entities/monitoring/actual/politicallyexposed/politicallyexposedmatch/politically-exposed-match.component';
import { BadPressMatchComponent } from 'app/entities/monitoring/actual/badpress/badpressmatch/bad-press-match.component';

import { UpdateElaborationComponent } from 'app/entities/monitoring/actual/elaboration/updateelaboration/update-elaboration.component';

import {
    UpdateSanctionInfoComponent
} from 'app/entities/monitoring/actual/sanction/sanctioninfo/updatesanctioninfo/update-sanction-info.component';
import {
    UpdateSanctionMatchComponent
} from 'app/entities/monitoring/actual/sanction/sanctionmatch/updatesanctionmatch/update-sanction-match.component';
import { SanctionDetailsComponent } from 'app/entities/monitoring/actual/sanction/sanctiondetails/sanction-details.component';

import {
    UpdatePoliticallyExposedInfoComponent
} from 'app/entities/monitoring/actual/politicallyexposed/politicallyexposedinfo/updatepoliticallyexposedinfo/update-politically-exposed-info.component';

import {
    UpdateBadPressInfoComponent
} from 'app/entities/monitoring/actual/badpress/badpressinfo/updatebadpressinfo/update-bad-press-info.component';
import {
    UpdateBadPressMatchComponent
} from 'app/entities/monitoring/actual/badpress/badpressmatch/updatebadpressmatch/update-bad-press-match.component';
import { HistoryComponent } from 'app/entities/monitoring/history/history.component';
import { PoliticallyExposedService } from 'app/entities/monitoring/actual/politicallyexposed/politically-exposed.service';
import { MonitoringDashboardComponent } from 'app/entities/monitoring/dashboard/monitoring-dashboard.component';
import { HitDetailDialogComponent } from 'app/entities/monitoring/dashboard/hit-detail-dialog/hit-detail-dialog.component';
import { ResolveBulkHitsComponent } from 'app/entities/monitoring/dashboard/resolve-bulk-hits/resolve-bulk-hits.component';
import { VerifyNowDialogComponent } from 'app/entities/monitoring/dashboard/verify-now-dialog/verify-now-dialog.component';
import { MonitoringMatchIndicatorsComponent } from 'app/entities/monitoring/monitoring-match-indicators/monitoring-match-indicators.component';
import { AlertDetailDrawerComponent } from 'app/alerts/alert-detail-drawer.component';
import { AlertsModule } from 'app/alerts/alerts.module';

@NgModule({
    declarations: [
        EntityMonitoringComponent,
        EntityMonitoringClientComponent,
        EntityMonitoringOrgComponent,
        EntityMonitoringPersonComponent,
        MonitoringDashboardComponent,
        HitDetailDialogComponent,
        VerifyNowDialogComponent,
        MonitoringMatchIndicatorsComponent,
        ElaborationComponent,
        SanctionInfoComponent,
        PoliticallyExposedInfoComponent,
        BadPressInfoComponent,
        SanctionMatchComponent,
        PoliticallyExposedMatchComponent,
        BadPressMatchComponent,
        UpdateElaborationComponent,
        UpdateSanctionInfoComponent,
        UpdateSanctionMatchComponent,
        SanctionDetailsComponent,
        UpdatePoliticallyExposedInfoComponent,
        UpdateBadPressInfoComponent,
        UpdateBadPressMatchComponent,
        HistoryComponent,
        ResolveBadPressMatchComponent,
        ResolvePepMatchComponent,
        ResolveSanctionMatchComponent,
        ResolveBulkHitsComponent
    ],
    imports: [
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBw6zrtGzSpNfaPR1BOfMnqUnH6cONDyLk',
            libraries: ['places']
        }),
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        SharedModule,
        CalendarModule,
        TabViewModule,
        JustgageModule,
        MenubarModule,
        ConfirmDialogModule,
        EditorModule,
        AutoCompleteModule,
        CommonPipesModule,
        AlertsModule
    ],
    providers: [
        PoliticallyExposedService
    ],
    entryComponents: [
        UpdateElaborationComponent,
        UpdateSanctionInfoComponent,
        UpdateSanctionMatchComponent,
        SanctionDetailsComponent,
        UpdatePoliticallyExposedInfoComponent,
        UpdateBadPressInfoComponent,
        UpdateBadPressMatchComponent,
        ResolveBadPressMatchComponent,
        ResolvePepMatchComponent,
        ResolveSanctionMatchComponent,
        ResolveBulkHitsComponent,
        HitDetailDialogComponent,
        VerifyNowDialogComponent,
        AlertDetailDrawerComponent
    ],
    exports: [
        EntityMonitoringComponent,
        MonitoringMatchIndicatorsComponent
    ]
})

/**
 * Main module for the entity monitoring tab management.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
*/
export class EntityMonitoringModule { }



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/entity-monitoring.module.ts